//jacques-andre-editeur\proshop-v2\frontend\src\slices\subscribersApiSlice.js
import { SUBSCRIBERS_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const subscribersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSubscribers: builder.query({
      query: ({ pageNumber, isAdminSpace, parPage } = {}) => ({ // TESTER LA NECESSITE ET POSSIBILITE DE isAdminSpace
        url: SUBSCRIBERS_URL,
        method: 'GET',
        params: { pageNumber, isAdminSpace, parPage }, // TESTER LA NECESSITE ET POSSIBILITE DE isAdminSpace
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Subscribers'],
    }),

    createSubscriber: builder.mutation({
      query: (data) => ({
        url: SUBSCRIBERS_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Subscribers'],
    }),
    
    deleteSubscriber: builder.mutation({
      query: (id) => ({
        url: `${SUBSCRIBERS_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Subscribers'],
    }),
    
    toggleSubscriberRegistered: builder.mutation({
      query: (subscriberId) => ({
        url: `${SUBSCRIBERS_URL}/${subscriberId}/`,
        method: 'PUT',
      }),
      invalidatesTags: ['Subscribers'],
    }),

  }),
});  

export const {
  useGetSubscribersQuery,
  useCreateSubscriberMutation,
  useDeleteSubscriberMutation,
  useToggleSubscriberRegisteredMutation,
} = subscribersApiSlice;
